export default "__VITE_ASSET__CX819rIU__"